import $ from 'jquery';

export default class PageMeta {
  private static _metaMap: Map<string, string> | undefined;

  public static get(key: string): string | undefined {
    if (!PageMeta._metaMap) {
      const metaMap = new Map();
      $("head > meta[name]").each((_, elem) => {
        const $elem = $(elem);
        const nameAttr = $elem.attr("name");
        if (!nameAttr) {
          return;
        }
        const contentAttr = $elem.attr("content");
        if (!contentAttr) {
          return;
        }

        metaMap.set(nameAttr, contentAttr);
      });
      PageMeta._metaMap = metaMap;
    }

    return PageMeta._metaMap.get(key);
  }
}
